import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';


@Component({
  selector: 'app-force-logout-popup',
  templateUrl: './force-logout-popup.component.html',
  styleUrls: ['./force-logout-popup.component.css']
})
export class ForceLogoutPopupComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<ForceLogoutPopupComponent>) { }

  ngOnInit() {
  }

  cancel() {
    this.dialogRef.close({
      'Proceed': false
    });
  }

  proceed() {
    this.dialogRef.close({
      'Proceed': true
    });
  }
  
}
